let loaderPromise = null;

/**
 * Loads the Google Maps JavaScript API with the Places library exactly once.
 * Returns a Promise that resolves with `window.google` when ready.
 */
export function loadGoogleMaps() {
  if (typeof window === "undefined") return Promise.reject(new Error("SSR"));
  if (window.google && window.google.maps && window.google.maps.places) {
    return Promise.resolve(window.google);
  }
  if (loaderPromise) return loaderPromise;

  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!apiKey) return Promise.reject(new Error("REACT_APP_GOOGLE_MAPS_API_KEY is not set"));

  loaderPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById("google-maps-js");
    if (existing) {
      existing.addEventListener("load", () => resolve(window.google));
      existing.addEventListener("error", reject);
      return;
    }
    const script = document.createElement("script");
    script.id = "google-maps-js";
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&libraries=places&v=weekly`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.google);
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return loaderPromise;
}
